import { useState } from 'react'
import { Card, Spin } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import './Charactercard.css'
import { useNavigate } from 'react-router-dom'

const CharacterCard = ({ id, img, thumbImg, name, desc, enabled }) => {
  const navigate = useNavigate()
  const params = new URLSearchParams()
  params.append('img', img)
  params.append('thumbImg', thumbImg)
  params.append('name', name)
  params.append('desc', desc)
  params.append('enabled', enabled)

  const [dataLoaded, setDataLoaded] = useState(true)

  const handleClickOpen = () => {
    navigate(`/characters/main/edit/${id}?${params.toString()}`)
  }

  return (
    <div>
      {dataLoaded ? (
        <Card
          hoverable
          className={`card-container ${enabled ? '' : 'faded-card'}`}
          cover={
            <div className="card-cover">
              <img alt={name} src={img} className="card-image" />
              <EditOutlined onClick={handleClickOpen} className="edit-icon" />
            </div>
          }
        >
          <Card.Meta
            title={name}
            description={<div className="card-description">{desc}</div>}
          />
        </Card>
      ) : (
        <div className="spinner-container">
          <Spin size="large" />
        </div>
      )}
    </div>
  )
}

export default CharacterCard
